import React from 'react';

const Success = () => (
  <div className="success-page" style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '3rem 1rem' }}>
    <h1 style={{ color: '#7C3C68', fontSize: '2.5rem', marginBottom: '1rem' }}>Thank You for Your Purchase!</h1>
    <p style={{ fontSize: '1.2rem', color: '#42213D', maxWidth: 500, textAlign: 'center' }}>
      Your order was successful. You’ll receive a confirmation email soon.<br/>
      If you have any questions, feel free to <a href="/contact" style={{ color: '#7C3C68', textDecoration: 'underline' }}>contact me</a>.
    </p>
  </div>
);

export default Success; 